import { createSlice } from '@reduxjs/toolkit';
import { getWalletSummary } from './thunk';

export const initialState = {
  isLoading: false,
  summary: {},
  error: {},
  isError: false,
};

const walletSummarySlice = createSlice({
  name: 'WalletSummary',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWalletSummary.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getWalletSummary.fulfilled, (state, action) => {
      state.isLoading = false;
      state.summary = action.payload?.data || action.payload;
    });
    builder.addCase(getWalletSummary.rejected, (state, action) => {
      state.isError = true;
      state.error = action.payload?.error || null;
    });
  },
});

export default walletSummarySlice.reducer;
